'use client'
import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
import {Accordion, Col, Container, Row} from "react-bootstrap";
import {CSSPlugin, gsap, TimelineLite} from "gsap";
import {usePathname} from "next/navigation";
import Link from "next/link";
import SvgButton from "@/components/SvgButton";
import {hover, Transition, white} from "@/styles/globalStyleVars";


const MobileMenu = ({color, isProjectPage, isLandowner}) => {
    const location = usePathname();
    gsap.registerPlugin(CSSPlugin);
    const tl = new TimelineLite();
    const mobileMenuRaf = useRef();
    const menuRef = useRef();
    const hamburgerRef = useRef();
    const hamburgerCloseRef = useRef();

    const [scrollUp, setScrollUp] = useState(false);
    const [scrollDown, setScrollDown] = useState(false);
    const [isSticky, setIsSticky] = useState(false);



    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

    // Update the viewport height variable on resize
    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);










    //---- on scroll menu fixed action
    useEffect(() => {
        if (document.body.classList.contains("scroll-down")) {
            document.body.classList.remove("scroll-down");
        }
    });

    useEffect(() => {
        const body = document.body;
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;
        let howMuchScroll = 150;

        if (window.screen.width > 991) {
            howMuchScroll = 80;
        } else {
            howMuchScroll = 150;
        }

        window.addEventListener("scroll", () => {
            const tl = new TimelineLite();
            let currentScroll = window.pageYOffset;

            if (currentScroll <= 0) {
                body.classList.remove(scrollUp);
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
                // down
                body.classList.remove(scrollUp);
                body.classList.add(scrollDown);
                tl.to(".contact-button__content", {
                    duration: 0.4,
                    height: 0,
                    opacity: 0,
                    padding: "0 30px",
                }).to(
                    ".contact-button__content",
                    {
                        duration: 0,
                        display: "none",
                    },
                    "-=.2"
                );
                document
                    .querySelector(".contact-button .db-btn")
                    ?.classList.remove("menu-slide");
            } else if (
                currentScroll < lastScroll &&
                body.classList.contains(scrollDown)
            ) {
                // up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        });
    }, []);

    useEffect(() => {
        // menu click on mobile
        if (hamburgerRef.current) {
            hamburgerRef.current.addEventListener("click", handleMenuOpen);
        }
        if (hamburgerCloseRef.current) {
            hamburgerCloseRef.current.addEventListener("click", handleMenuClose);
        }

        const getLinkTag = document.querySelectorAll("a");
        for (let i of getLinkTag) {
            i.addEventListener("click", handleMenuClose);
        }

        return () => {
            if (hamburgerRef.current) {
                hamburgerRef.current.removeEventListener("click", handleMenuOpen);
            }
            if (hamburgerCloseRef.current) {
                hamburgerCloseRef.current.removeEventListener("click", handleMenuClose);
            }

            // Remove event listeners from link tags
            for (let i of getLinkTag) {
                i.removeEventListener("click", handleMenuClose);
            }
        };
    }, []);


    const handleMenuOpen = () => {
        document.querySelector(".hamburger").classList.add("menu-open");
        document.querySelector(".Mobile-menu-wrap").classList.add("menu-visible");
        document.body.classList.add("menu-showed");

        // Set the body's overflow to hidden
        gsap.set(document.body, {
            overflow: "hidden",
        });

        gsap.to(menuRef.current, {
            display: "block",
            opacity: 1,
            duration: 0.3,
        });
    };

    const handleMenuClose = () => {
        document.querySelector(".hamburger").classList.remove("menu-open");
        document.querySelector(".Mobile-menu-wrap").classList.remove("menu-visible");
        document
            .querySelector(".Mobile-menu-wrap")
            .classList.remove("contact-slided");
        document.body.classList.remove("menu-showed");

        // Set the body's overflow to visible
        gsap.set(document.body, {
            overflow: "visible",
        });

        gsap.to(menuRef.current, {
            opacity: 0,
            duration: 0.2,
            onComplete: function () {
                gsap.set(menuRef.current, {
                    display: "none",
                });
            },
        });
    };

    const menuIconW=`<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0.499451C1 0.499451 4.58 0.499451 9 0.499451C13.42 0.499451 17 0.499451 17 0.499451" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 7.49945C1 7.49945 4.58 7.49945 9 7.49945C13.42 7.49945 17 7.49945 17 7.49945" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 14.4995C1 14.4995 4.58 14.4995 9 14.4995C13.42 14.4995 17 14.4995 17 14.4995" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
    const demo=`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.11812 12C6.07838 12 6.03865 12 5.99864 11.9998C5.05803 12.0021 4.18891 11.9782 3.3437 11.9268C2.56879 11.8796 1.86146 11.6118 1.29804 11.1524C0.754396 10.7091 0.383149 10.1097 0.194642 9.37106C0.0305787 8.72799 0.0218812 8.09673 0.0135498 7.48616C0.00750733 7.04808 0.00128174 6.52898 0 6.00108C0.00128174 5.47099 0.00750733 4.95188 0.0135498 4.5138C0.0218812 3.90333 0.0305787 3.27207 0.194642 2.62891C0.383149 1.89026 0.754396 1.29086 1.29804 0.847564C1.86146 0.388151 2.56879 0.120359 3.34379 0.0732087C4.18901 0.0218475 5.0583 -0.00213939 6.00093 0.000149441C6.94182 -0.00186473 7.81066 0.0218475 8.65588 0.0732087C9.43078 0.120359 10.1381 0.388151 10.7015 0.847564C11.2453 1.29086 11.6164 1.89026 11.8049 2.62891C11.969 3.27198 11.9777 3.90333 11.986 4.5138C11.9921 4.95188 11.9984 5.47099 11.9996 5.99888V6.00108C11.9984 6.52898 11.9921 7.04808 11.986 7.48616C11.9777 8.09664 11.9691 8.7279 11.8049 9.37106C11.6164 10.1097 11.2453 10.7091 10.7015 11.1524C10.1381 11.6118 9.43078 11.8796 8.65588 11.9268C7.84646 11.976 7.01497 12 6.11812 12ZM5.99864 11.0623C6.92397 11.0645 7.77358 11.0412 8.59893 10.991C9.18487 10.9554 9.6929 10.7652 10.1091 10.4258C10.4938 10.1121 10.7588 9.67922 10.8965 9.13924C11.0331 8.60393 11.041 8.02916 11.0486 7.47335C11.0546 7.03819 11.0608 6.52275 11.0621 5.99998C11.0608 5.47712 11.0546 4.96177 11.0486 4.52662C11.041 3.9708 11.0331 3.39603 10.8965 2.86063C10.7588 2.32065 10.4938 1.88779 10.1091 1.57404C9.6929 1.23474 9.18487 1.04459 8.59893 1.00897C7.77358 0.958709 6.92397 0.935546 6.00084 0.93756C5.0757 0.935363 4.22599 0.958709 3.40064 1.00897C2.8147 1.04459 2.30668 1.23474 1.89048 1.57404C1.50577 1.88779 1.24082 2.32065 1.10303 2.86063C0.966433 3.39603 0.95856 3.97071 0.950961 4.52662C0.94501 4.96214 0.938784 5.47786 0.937502 6.00108C0.938784 6.52202 0.94501 7.03783 0.950961 7.47335C0.95856 8.02916 0.966433 8.60393 1.10303 9.13924C1.24082 9.67922 1.50577 10.1121 1.89048 10.4258C2.30668 10.7651 2.8147 10.9553 3.40064 10.9909C4.22599 11.0412 5.07588 11.0646 5.99864 11.0623ZM5.9763 8.92968C4.36094 8.92968 3.04661 7.61544 3.04661 5.99998C3.04661 4.38453 4.36094 3.07029 5.9763 3.07029C7.59176 3.07029 8.906 4.38453 8.906 5.99998C8.906 7.61544 7.59176 8.92968 5.9763 8.92968ZM5.9763 4.00779C4.87785 4.00779 3.98411 4.90153 3.98411 5.99998C3.98411 7.09844 4.87785 7.99218 5.9763 7.99218C7.07485 7.99218 7.9685 7.09844 7.9685 5.99998C7.9685 4.90153 7.07485 4.00779 5.9763 4.00779ZM9.23412 2.13278C8.84585 2.13278 8.531 2.44754 8.531 2.83591C8.531 3.22428 8.84585 3.53904 9.23412 3.53904C9.62249 3.53904 9.93725 3.22428 9.93725 2.83591C9.93725 2.44754 9.62249 2.13278 9.23412 2.13278Z" fill="white"/>
</svg>
`
    const fb=`<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.04494 12V6.52664H5.88138L6.1569 4.39294H4.04494V3.03088C4.04494 2.41332 4.21573 1.99246 5.10231 1.99246L6.23124 1.99199V0.083538C6.03601 0.0581672 5.36585 0 4.58585 0C2.95709 0 1.84201 0.994179 1.84201 2.81956V4.39294H0V6.52664H1.84201V12H4.04494Z" fill="white"/>
</svg>
`
    const ln=`
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.45525 0C0.575317 0 0 0.577807 0 1.33725C0 2.07993 0.558178 2.67421 1.42148 2.67421H1.43818C2.33532 2.67421 2.89365 2.07993 2.89365 1.33725C2.87688 0.577807 2.33532 0 1.45525 0ZM0.151944 3.73056H2.72435V11.4698H0.151944V3.73056ZM6.72032 4.85332C6.72032 4.85332 7.65086 3.54932 9.03858 3.54932C10.7309 3.54932 12 4.65549 12 7.03264V11.4702H9.42786V7.32993C9.42786 6.28952 9.05557 5.57981 8.12474 5.57981C7.41407 5.57981 6.99088 6.05844 6.80491 6.52045C6.73695 6.68591 6.72017 6.91691 6.72017 7.14828V11.4702H4.14784V3.73096H6.72032V4.85332Z" fill="white"/>
</svg>
    `
    const youtube=`<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.7528 1.3147C11.6145 0.800612 11.2092 0.395362 10.6951 0.256934C9.7561 0 5.99987 0 5.99987 0C5.99987 0 2.24378 0 1.30474 0.247193C0.800612 0.385474 0.385401 0.800685 0.24712 1.3147C0 2.25367 0 4.20096 0 4.20096C0 4.20096 0 6.15807 0.24712 7.08722C0.385548 7.60124 0.790724 8.00649 1.30481 8.14491C2.25367 8.40192 6.00001 8.40192 6.00001 8.40192C6.00001 8.40192 9.7561 8.40192 10.6951 8.15473C11.2092 8.01637 11.6145 7.61112 11.7529 7.09711C11.9999 6.15807 11.9999 4.21085 11.9999 4.21085C11.9999 4.21085 12.0098 2.25367 11.7528 1.3147ZM4.80396 5.99994V2.40198L7.92746 4.20096L4.80396 5.99994Z" fill="white"/>
</svg>
`
    const twitter=`
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.98807 5.08118L11.3593 0H10.3234L6.52792 4.41192L3.49645 0H0L4.58418 6.6716L0 12H1.0359L5.04407 7.34086L8.24552 12H11.742L6.98781 5.08118H6.98807ZM5.56927 6.73038L5.10479 6.06604L1.40914 0.779804H3.00022L5.98265 5.04596L6.44712 5.71031L10.3239 11.2557H8.73286L5.56927 6.73063V6.73038Z" fill="white"/>
</svg>
    `


    return (

        <StyledMobileMenu viewportHeight={viewportHeight}
            className={`${isSticky ? 'sticky' : ''} ${scrollDown ? 'scroll-down' : ''} ${scrollUp ? 'scroll-up' : ''}  ${isProjectPage || isLandowner ? 'menu-v2' : ''}  main-menu-desktop Mobile-menu-wrap menu-bar`}>
            <Container>
                <Row className="mobile-menu" ref={mobileMenuRaf}>
                    <Col className="logo">
                        <Link href={'/'} prefetch={true} className={'logo_normal'}>
                            <img height={50} src={'/images/static/logo.svg'} alt={'Unimass Property Solution'}/>
                        </Link>
                        <Link href={'/'} prefetch={true} className={'logo_sticky'}>
                            <img height={50} src={'/images/static/logo.svg'} alt={'Unimass Property Solution'}/>
                        </Link>
                    </Col>

                    <Col className="hamburger">
                          <span ref={hamburgerRef} className={'hamburger_menu'}>
                              <SvgButton svg={menuIconW}
                                         borderColor={`${white}`}
                                         width={40}
                                         height={40}
                              />
                          </span>

                        <span ref={hamburgerCloseRef} className={'hamburger_close'}>
                            <SvgButton svg={`<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="19.5" stroke="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8536 12.1464C12.6583 11.9512 12.3417 11.9512 12.1464 12.1464C11.9512 12.3417 11.9512 12.6583 12.1464 12.8536L19.2947 20.0018L12.1464 27.1501C11.9512 27.3454 11.9512 27.662 12.1464 27.8572C12.3417 28.0525 12.6583 28.0525 12.8536 27.8572L20.0018 20.7089L27.1501 27.8572C27.3454 28.0525 27.662 28.0525 27.8572 27.8572C28.0525 27.662 28.0525 27.3454 27.8572 27.1501L20.7089 20.0018L27.8572 12.8536C28.0525 12.6583 28.0525 12.3417 27.8572 12.1464C27.662 11.9512 27.3454 11.9512 27.1501 12.1464L20.0018 19.2947L12.8536 12.1464Z" fill="white"/>
</svg>
`}
                                       borderColor={`${white}`}
                                       // width={40}
                                       // height={40}
                            />
                         </span>
                    </Col>

                    <div className="mobile-menu__items" ref={menuRef}>

                        <ul className="mobile-menu__items__ul">
                            <Accordion defaultActiveKey="">

                                <Accordion.Item eventKey="0">
                                    <Accordion.Header
                                        className={`has-child ${location === '/about' ? 'active' : ''}`}>
                                        About Us <img src={'/images/static/down.svg'}/>

                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>
                                                <Link prefetch={true} href={"/about#who_we_are"}> Who We Are
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/about#bod"}>Board of Directors
                                                </Link>
                                            </li>

                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header
                                        className={`has-child ${location === '/' ? 'active' : ''}`}>
                                        Projects<img src={'/images/static/down.svg'}/>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            <li>
                                                <Link prefetch={true} href={"/project?category=rent"}> Rent
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/project?category=buy"}> Buy
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/project?type=residential"}> Residential
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/project?type=commercial"}> Commercial
                                                </Link>
                                            </li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header
                                        className={`has-child ${location === '/' ? 'active' : ''}`}>
                                        Service<img src={'/images/static/down.svg'}/>

                                    </Accordion.Header>
                                    <Accordion.Body>

                                        <ul>
                                            <li>
                                                <Link prefetch={true} href={"/service/interior-solutions"}> Interior Solutions
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/service/re-sale-of-property"}> Re-Sale of Property
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/service/renovations-and-modification"}> Renovations & Modifications
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/service/legal-logistics-services"}> Legal and Logistics Services
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/service/design-consultancy-serives"}> Design Consultancy Services
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/service/rental-services"}> Rental Services
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/service/building-management"}>Building Management
                                                </Link>
                                            </li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header
                                        className={`has-child ${location === '/' ? 'active' : ''}`}>
                                        Media Center<img src={'/images/static/down.svg'}/>

                                    </Accordion.Header>
                                    <Accordion.Body>

                                        <ul>
                                            <li>
                                                <Link prefetch={true} href={"/news-events?status=events"}> Events
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/news-events?status=news"}> News
                                                </Link>
                                            </li>
                                            <li>
                                                <Link prefetch={true} href={"/news-events?status=blogs"}> Blog
                                                </Link>
                                            </li>
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <li className={location === '/career' ? 'active' : ''}>
                                    <Link prefetch={true} href={"/career"}>
                                        Career
                                    </Link>
                                </li>
                                <li className={location === '/contact-us' ? 'active' : ''}>
                                    <Link prefetch={true} href={"/contact-us"}>
                                        Contact Us
                                    </Link>
                                </li>
                                <li className={location === '/start-with-us' ? 'active' : ''}>
                                    <Link prefetch={true} href={"/start-with-us"}>
                                        Begin Your Journey
                                    </Link>
                                </li>
                                <li >
                                    <Link prefetch={true} href={"https://unimassbd.com/"} target={'_blank'}>
                                        Unimass Holdings Ltd.
                                    </Link>
                                </li>

                            </Accordion>
                        </ul>

                        <div className={'social'}>
                            <div className={'addressess'}>
                                <div className={'address'}>
                                    <p>Address</p>
                                    <p><Link href={'https://maps.app.goo.gl/vd5Q7KPCMBRtsbJY6'} target={'_blank'}>House 04, Road 28(Old) 15 (New),<br/> Dhanmondi, Dhaka 1209</Link></p>
                                </div>
                                <div className={'address'}>
                                    <p>Call</p>
                                    <p><Link href={'tel:+8841020276'}>+8802 41020276-8</Link></p>
                                </div>
                                <div className={'address'}>
                                    <p>Email</p>
                                    <p><Link href={'mailto:info@ups-bd.com'}>info@ups-bd.com</Link></p>
                                </div>
                            </div>

                            <div>
                                <li><Link href={'https://www.facebook.com/unimasspropertysolutions/'} target="_blank">
                                    <SvgButton svg={fb}
                                               borderColor={`${white}`}
                                               width={30}
                                               height={30}
                                    />
                                </Link></li>
                                <li >
                                    <Link href={'https://www.instagram.com/unimassbd121/'} target="_blank">
                                        <SvgButton svg={demo}
                                                   borderColor={`${white}`}
                                                   width={30}
                                                   height={30}
                                        />
                                    </Link></li>
                                <li >
                                    <Link href={'https://www.linkedin.com/company/unimass-holdings-limited/'} target="_blank">
                                        <SvgButton svg={ln}
                                                   borderColor={`${white}`}
                                                   width={30}
                                                   height={30}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href={'https://www.youtube.com/@unimassholdingsltd7942'} target="_blank">
                                        <SvgButton svg={youtube}
                                                   borderColor={`${white}`}
                                                   width={30}
                                                   height={30}
                                        />
                                    </Link>
                                </li>
                                <li>
                                    <Link href={'https://twitter.com/unimass-holdings-limited'} target="_blank">
                                        <SvgButton svg={twitter}
                                                   borderColor={`${white}`}
                                                   width={30}
                                                   height={30}
                                        />
                                    </Link>
                                </li>
                            </div>
                        </div>
                    </div>

                </Row>
            </Container>
        </StyledMobileMenu>
    );
};



const StyledMobileMenu = styled.section`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    z-index: 9999;
    display: flex;
    align-items: center;
    overflow: visible !important;
    //box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    //display: none;
    transition: all 0.7s ${Transition};
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);

    .logo_sticky {
        display: none;
    }

    &.menu-visible {
        //position: relative;
        z-index: 10;
        background-color: #3D342D !important;
        transition: 0.8s all ${Transition};
    }

    .dc-btn {
        width: 100%;
    }


    .mobile-menu {
        .logo {
            display: flex;
            align-items: center;
        }

        .hamburger {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .hamburger_close {
                display: none;
            }

            &.menu-open {
                .hamburger_menu {
                    display: none;
                }

                .hamburger_close {
                    display: block;
                }

            }
        }

        &__items {
            display: none;
            position: absolute;
            opacity: 0;
            background-color: #3D342D;
            height: calc(var(--vh, 1vh) * 100 - 50px);
            top: 60px;
            left: 0;
            width: 100%;
            z-index: 99;
            padding: 55px 15px 80px 15px;
            //overflow: auto;
            transition: all .4s ${Transition};
            overflow: auto;

            .mobile-menu__items__contact {
                height: 40px;
                width: 100%;
                border-radius: 24px;
                text-align: center;
                background-color: ${hover};
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 70px;
                margin-top: 10px;

                p {
                    font-size: 16px;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 24px;

                }


            }

            &__top {
                ul {
                    li {
                        a {
                            height: 35px;
                            border-radius: 18px;
                            background-color: rgba(136, 136, 136, 0.5);
                            color: #ffffff;
                            font-size: 12px;
                            font-weight: 600;
                            line-height: 18px;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-bottom: 30px;

                            img {
                                margin-right: 10px !important;
                            }
                        }

                        &:nth-last-child(1) a {
                            margin-bottom: 60px;
                            background-color: ${hover};

                            &:hover {
                                color: #ffffff !important;
                            }
                        }
                    }
                }
            }

            &__ul {
                li {
                    padding-bottom: 20px;
                    border-bottom: 1px solid rgb(255 255 255 / 20%);
                    margin-bottom: 20px;

                    &:nth-last-child(1) {
                        border-bottom: 0;
                    }

                    a {
                        color: rgb(255 255 255 / 70%);
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 28px;
                    }

                    &.active {
                        border-color: rgb(255 255 255 / 20%);

                        a {
                            color: rgb(255 255 255 / 70%);
                        }
                    }
                }
            }

            .social {
                display: flex;
                justify-content: space-between;
                gap: 20px;
                margin-top: 40px;
                li {
                    margin-bottom: 15px;
                }

                .addressess {
                    .address {
                        margin-bottom: 20px;

                        a {
                            font-size: 14px;
                            line-height: 21px;
                            font-weight: 400;
                            color: rgba(255, 255, 255);

                        }

                        p {

                            &:first-child {
                                font-size: 12px;
                                line-height: 18px;
                                font-weight: 500;
                                color: rgba(255, 255, 255, 0.5);
                                margin-bottom: 15px;
                            }
                        }
                    }
                }
            }

            @media (min-width: 768px) and (max-width: 991px) {
                padding: 55px 55px 60px 55px;
            }
        }
    }

    &.menu-open {
        .mobile-menu__items {
            display: block;
        }
    }

    //accordion

    .accordion {
        background-color: #3D342D;
        z-index: 5;
        position: relative;

        .accordion-item {
            .accordion-header {
                .accordion-button {
                    background-color: transparent;
                    text-transform: capitalize;
                    width: 100%;
                    text-align: left;
                    display: flex;
                    justify-content: space-between;
                    padding: 0;
                    box-shadow: none;
                    border: none;
                    padding-bottom: 20px;
                    //border-bottom: 1px solid rgb(255 255 255 / 20%);
                    color: rgb(255 255 255 / 70%);
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 28px;
                    transition: all 0.5s ${Transition};

                    &.collapsed {
                        border-bottom: 1px solid rgb(255 255 255 / 20%) !important;
                        color: rgb(255 255 255 / 70%);
                        margin-bottom: 20px;
                        transition: all 0.5s ${Transition};
                    }

                    &[aria-expanded="true"] {
                        img {
                            transform: rotate(180deg);
                        }
                    }

                    img {
                        width: 15px;
                        height: 15px;
                        margin-top: 6px;
                        transition: all 0.5s ${Transition};


                    }

                    &.collapsed {

                    }

                    &.collapsed {
                        border-bottom: 1px solid #e1e4e6;
                    }
                }

                &.active {
                    .accordion-button {
                        border-bottom: 1px solid rgb(255 255 255 / 20%);
                        color: rgb(255 255 255 / 70%);
                    }
                }
            }

            .accordion-body {
                padding-bottom: 5px;
                border-bottom: 1px solid rgb(255 255 255 / 20%);
                margin-bottom: 20px;
                padding-top: 20px;

                ul {
                    li {
                        border: none;
                        padding: 0;
                        margin: 0;
                        font-size: 16px !important;
                        line-height: 20px !important;


                        a {
                            font-size: 16px;
                            line-height: 20px;
                            font-weight: 500;
                            color: #FFFFFF;
                            padding: 15px 0;
                            //margin-bottom: 20px;
                            //border-bottom: 1px solid rgba(255, 255, 255, 0.5);
                            display: block;

                            svg {
                                display: none;
                            }

                        }

                        &:nth-of-type(1) a {
                            padding-top: 0;
                        }

                        &:nth-last-of-type(1) a {
                            border: none;
                        }
                    }
                }
            }

            &:nth-last-child(1) {
                .accordion-button {
                    &.collapsed {
                        border: none;
                    }

                }
            }
        }
    }


    @media (min-width: 992px) {
        display: none;
    }


    .contact-info {
        position: fixed;
        height: 100vh;
        top: 85px;
        left: 0px;
        right: 0px;
        background-color: #061524;
        padding: 50px 15px 20px 15px;
        transform: translate3d(100vw, 0px, 0px) !important;
        transition: all .4s ${Transition};

        &__top {
            p {
                font-size: 20px;
                font-weight: 300;
                line-height: 28px;
                color: #FFFFFF;
                display: flex;
                margin-bottom: 60px;

                img {
                    margin-right: 20px;

                }
            }

            a {
                font-size: 20px;
                line-height: 28px;
                font-weight: 500;
                color: #FFFFFF !important;
                display: flex;
                width: 100%;
                justify-content: space-between;
                padding-bottom: 20px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.5);
                margin-bottom: 40px;
            }
        }


        &__desc {
            &__single {
                &:nth-of-type(1) {
                    margin-bottom: 40px;
                }

                h4 {
                    font-size: 12px;
                    line-height: 24px;
                    color: rgba(255, 255, 255, 0.5);
                }

                a {
                    color: #FFFFFF !important;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                    border: 0
                }
            }

        }
    }



`;
export default React.memo(MobileMenu);
